const tabs = [
  { id: 'all', label: 'All', count: 6 },
  { id: 'whistleblowing', label: 'Whistleblowing', count: 3 },
  { id: 'gifts', label: 'Gifts & interests', count: 2 },
  { id: 'code-of-conduct', label: 'Code of conduct', count: 1 }
];

const cards = [
  { label: 'Open matters', value: '4', note: 'Live', accent: 'dark' },
  { label: 'Whistleblowing cases', value: '3', note: 'Protected disclosures', accent: 'amber' },
  { label: 'Under investigation', value: '3', note: 'In workflow', accent: 'amber' },
  { label: 'Confidential', value: '3', note: 'Restricted access', accent: 'red' }
];

const rows = [
  {
    ref: 'WB-01',
    matter: 'Suspected supplier collusion (anonymous)',
    type: 'Whistleblowing',
    confidentiality: 'Restricted',
    filter: 'whistleblowing',
    subtitle: 'Protected disclosure',
    status: { label: 'Investigation', class: 'bg-warning-subtle text-warning-emphasis' },
    details: [
      ['Matter', 'Anonymous report of supplier collusion on a tender'],
      ['Type', 'Whistleblowing - protected disclosure'],
      ['Confidentiality', 'Restricted - investigator only'],
      ['Investigator', 'Forensic - independent'],
      ['Status', 'Investigation in progress']
    ],
    connected_records: [
      ['Incident', 'Linked case', 'bi-bug'],
      ['Procurement', 'Tender records', 'bi-cart3'],
      ['Conflicts', 'Related parties', 'bi-person-lines-fill'],
      ['Legal matters', 'If litigated', 'bi-scales'],
      ['Risk', 'Collusion risk', 'bi-exclamation-triangle'],
      ['Evidence', 'Investigation evidence', 'bi-clipboard-check'],
      ['Audits', 'SCM audit', 'bi-journal-text']
    ],
    recommendation: 'Keep this strictly confidential. Run the five-stage investigation, link the procurement event, and protect the discloser from retaliation throughout.',
    primary_action: 'Open investigation'
  },
  {
    ref: 'GF-07',
    matter: 'Hospitality declared - supplier event',
    type: 'Gift',
    confidentiality: 'Standard',
    filter: 'gifts',
    subtitle: 'Gifts & hospitality register',
    status: { label: 'Cleared', class: 'bg-success-subtle text-success-emphasis' },
    details: [
      ['Matter', 'Hospitality received from a supplier'],
      ['Type', 'Gift / hospitality'],
      ['Value', 'R 1 800'],
      ['Confidentiality', 'Standard'],
      ['Status', 'Cleared - below threshold, declared']
    ],
    connected_records: [
      ['Conflicts', 'Declarations', 'bi-person-lines-fill'],
      ['Supplier', 'Supplier register', 'bi-building']
    ],
    recommendation: 'Properly declared and within threshold. No action beyond keeping it on the gifts register for the annual ethics report.',
    primary_action: 'View declaration'
  },
  {
    ref: 'WB-02',
    matter: 'Procurement irregularity report',
    type: 'Whistleblowing',
    confidentiality: 'Restricted',
    filter: 'whistleblowing',
    subtitle: 'Protected disclosure',
    status: { label: 'Triage', class: 'bg-warning-subtle text-warning-emphasis' },
    details: [
      ['Matter', 'Report of irregular procurement process'],
      ['Type', 'Whistleblowing'],
      ['Confidentiality', 'Restricted'],
      ['Status', 'Triage - assessing severity']
    ],
    connected_records: [
      ['Procurement', 'Affected RFQ', 'bi-cart3'],
      ['Audits', 'SCM audit', 'bi-journal-text'],
      ['Risk', 'Procurement risk', 'bi-exclamation-triangle'],
      ['Evidence', 'Disclosure evidence', 'bi-clipboard-check'],
      ['Reports', 'Ethics report', 'bi-file-earmark-text']
    ],
    recommendation: 'Complete triage and assign an investigator within the SLA. If substantiated it likely feeds the AGSA SCM findings - flag to Internal Audit.',
    primary_action: 'Assign investigator'
  },
  {
    ref: 'OI-03',
    matter: 'Director outside business interest',
    type: 'Outside interest',
    confidentiality: 'Standard',
    filter: 'gifts',
    subtitle: 'Outside interests register',
    status: { label: 'Under review', class: 'bg-warning-subtle text-warning-emphasis' },
    details: [
      ['Matter', 'Declared directorship in an external company'],
      ['Type', 'Outside interest'],
      ['Confidentiality', 'Standard'],
      ['Status', 'Under review - related-party check running']
    ],
    connected_records: [
      ['Conflicts', 'Conflict check', 'bi-person-lines-fill']
    ],
    recommendation: 'Run the related-party match against the supplier master. If the entity transacts with us, apply a recusal and document mitigations.',
    primary_action: 'Open conflict check'
  },
  {
    ref: 'CC-22',
    matter: 'Code of conduct acknowledgement',
    type: 'Code of conduct',
    confidentiality: 'Standard',
    filter: 'code-of-conduct',
    subtitle: 'Annual attestation campaign',
    status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' },
    details: [
      ['Matter', 'Annual code of conduct acknowledgement'],
      ['Type', 'Code of conduct'],
      ['Completion', '181 / 218 - 83%'],
      ['Status', 'In progress']
    ],
    connected_records: [
      ['Employees', 'Staff register', 'bi-people'],
      ['Training', 'Ethics training', 'bi-mortarboard']
    ],
    recommendation: '37 staff are outstanding. Send the reminder and escalate non-responders to line managers before the campaign closes.',
    primary_action: 'Remind outstanding'
  },
  {
    ref: 'WB-03',
    matter: 'Retaliation concern - closed',
    type: 'Whistleblowing',
    confidentiality: 'Restricted',
    filter: 'whistleblowing',
    subtitle: 'Protected disclosure',
    status: { label: 'Closed', class: 'bg-success-subtle text-success-emphasis' },
    details: [
      ['Matter', 'Concern of retaliation after a disclosure'],
      ['Type', 'Whistleblowing'],
      ['Confidentiality', 'Restricted'],
      ['Status', 'Closed - no retaliation substantiated']
    ],
    connected_records: [],
    recommendation: 'Closed with documented findings. Keep the discloser on a light-touch follow-up to confirm no later retaliation.',
    primary_action: 'View closure'
  }
];

export default {
  name: 'ComplyonEthicsWhistleblowing',
  data: () => ({
    tabs,
    active_tab: 'all',
    cards,
    rows,
    search_query: '',
    active_drawer_ref: null
  }),
  computed: {
    filtered_rows() {
      const query = this.search_query.trim().toLowerCase();

      return this.rows.filter((row) => {
        const matches_tab = this.active_tab === 'all' || row.filter === this.active_tab;
        const matches_query = !query || [row.ref, row.matter, row.type, row.confidentiality, row.status.label]
          .some((value) => String(value || '').toLowerCase().includes(query));

        return matches_tab && matches_query;
      });
    },
    active_drawer_data() {
      return this.rows.find((row) => row.ref === this.active_drawer_ref) || null;
    }
  },
  beforeUnmount() {
    document.body.classList.remove('audit-drawer-open');
  },
  methods: {
    set_tab(tab_id) {
      this.active_tab = tab_id;
    },
    open_drawer(ref) {
      this.active_drawer_ref = ref;
      document.body.classList.add('audit-drawer-open');
    },
    close_drawer() {
      this.active_drawer_ref = null;
      document.body.classList.remove('audit-drawer-open');
    }
  }
};
